import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import ReactQuill from 'react-quill-new'
import 'quill/dist/quill.snow.css'

import { theme } from '../../themes/theme'
import { FlexColumn } from '../styles/Containers'
import { registerVariableBlot } from '../../util/variableBlot'

const readOnlyModules = {
  toolbar: false
}

const readOnlyFormats = ['header', 'bold', 'italic', 'underline', 'strike', 'color', 'list', 'link', 'variable']

const EditorWrapper = styled(FlexColumn)`
  min-width: 0;
  max-width: 100%;
`

const Container = styled.div`
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
  background: ${theme.colors.background.medium};
  border-radius: ${theme.borderRadius.div};
  padding: 15px;

  .quill {
    min-width: 0;
    max-width: 100%;
  }

  .ql-toolbar {
    display: none !important;
  }

  .ql-container {
    border: none !important;
    background: transparent !important;
    font-family: ${theme.fonts.body};
  }

  .ql-editor {
    min-height: 0;
    padding: 0 !important;
    font-size: 14px;
    line-height: 24px;
    overflow-wrap: anywhere;
  }

  .ql-editor p {
    margin: 0;
  }

  .variable-tag {
    background: ${theme.colors.background.white};
    border-radius: ${theme.borderRadius.iconButton};
    padding: 4px 8px;
    width: min-content;
    text-wrap: nowrap;
    font-size: 12px;
    font-weight: 500;
  }
`

function RichTextReadOnly({ value }) {
  const containerRef = useRef(null)
  const quillRef = useRef(null)

  useEffect(() => {
    if (!containerRef.current) return

    if (!quillRef.current) {
      registerVariableBlot(ReactQuill.Quill)

      quillRef.current = new ReactQuill.Quill(containerRef.current, {
        modules: readOnlyModules,
        formats: readOnlyFormats,
        readOnly: true,
        theme: 'snow'
      })
    }

    if (value) {
      const delta = quillRef.current.clipboard.convert({ html: value })
      quillRef.current.setContents(delta)
    } else {
      quillRef.current.setContents('')
    }
  }, [value])

  return (
    <EditorWrapper>
      <Container className="quill-readonly-wrapper">
        <div ref={containerRef} />
      </Container>
    </EditorWrapper>
  )
}

RichTextReadOnly.propTypes = {
  value: PropTypes.string
}

export default RichTextReadOnly
